import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import useAuthStore from "@/shared/zustand/authStore";
import useToastStore from "@/shared/zustand/toastStore";
import { InputText } from "primereact/inputtext";
import { Skeleton } from "primereact/skeleton";
import { Chip } from "primereact/chip";
import { getCWUser } from "@/core/api/api";
// interface UserDetails {
//   name: string;
//   email: string;
//   personna: string[];
// }
const ProfileTab = () => {
    const { user, isLoggedIn } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const [userDetails, setUserDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const fetchUserDetails = async () => {
        if (!user?.email) {
            showToast("error", "Error", "User email is not available");
            return;
        }
        try {
            setLoading(true);
            const { responseData, error } = await getCWUser(user.email);
            if (error) {
                console.error("Error while fetching user details: ", error);
                showToast("error", "Error", error.errorMessage);
                return;
            }
            // old code for api call
            // const response = await axios.get(
            //   `${process.env.VITE_BASE_API_URL}/user/${user?.email}`,
            //   {
            //     headers: {
            //       "Content-Type": "application/json",
            //     },
            //   }
            // );
            if (responseData) {
                setUserDetails(responseData);
            }
        }
        catch (error) {
            console.error("Error while fetching user details: ", error);
            showToast("error", "Error", "Failed to fetch user details");
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (isLoggedIn) {
            fetchUserDetails();
        }
    }, [isLoggedIn]);
    return (_jsxs("div", { className: "w-full h-full flex flex-col gap-y-6", children: [_jsxs("div", { children: [_jsx("h3", { className: "text-lg text-[#101828] font-medium", children: "Personal info" }), _jsx("p", { className: "text-base text-[#667085]", children: "View your personal details and account settings here." })] }), loading ? (_jsx("div", { className: "w-full", children: [1, 2, 3]?.map((key) => (_jsxs("div", { className: "w-full flex items-center gap-x-8 border-b border-[#EAECF0] py-6", children: [_jsx(Skeleton, { width: "200px", height: "42px" }), _jsx(Skeleton, { width: "100%", height: "42px", className: "flex-1  max-w-[640px]" })] }, key))) })) : (_jsxs("div", { className: "w-full", children: [_jsxs("div", { className: "w-full flex items-center gap-x-8 border-b border-[#EAECF0] py-6", children: [_jsx("span", { className: "w-fit md:w-[280px] text-sm md:text-base text-[#344054]", children: "Name" }), _jsx(InputText, { disabled: true, value: userDetails?.user_name, className: "flex-1 max-w-[640px] px-3 py-2 rounded-[8px] border border-[#D0D5DD]  disabled:text-[#344054] text-[#344054] opacity-70", placeholder: "Your Name...", readOnly: true, maxLength: 70 })] }), _jsxs("div", { className: "w-full flex items-center gap-x-8 border-b border-[#EAECF0] py-6", children: [_jsx("span", { className: "w-fit md:w-[280px] text-sm md:text-base text-[#344054]", children: "Email" }), _jsx(InputText, { disabled: true, type: "email", value: userDetails?.email, className: "flex-1 max-w-[640px] px-3 py-2 rounded-[8px] border border-[#D0D5DD] disabled:text-[#344054] text-[#344054] opacity-70", placeholder: "Your Email...", readOnly: true, maxLength: 70 })] }), _jsxs("div", { className: "w-full flex items-center gap-x-8 border-b border-[#EAECF0] py-6", children: [_jsx("span", { className: "w-fit md:w-[280px] text-sm md:text-base text-[#344054]", children: "Company Role" }), _jsx("div", { className: "flex-1", children: userDetails?.persona?.length ? (userDetails?.persona?.map((role, index) => (_jsx(Chip, { label: role, className: "bg-gradient-to-br from-[#f4f6fe] to-[#f6f4fe] mr-2 text-[#5928ED] border border-[#5928ED] text-xs" }, index)))) : (_jsx("span", { className: "text-gray-500 italic", children: "No persona assigned" })) })] })] }))] }));
};
export default ProfileTab;
